module.exports = __webpack_public_path__ + "img/41t.31890be2.jpg";